module.exports = __webpack_public_path__ + "img/icon-profile.782b9bbe.svg";